module.exports = __webpack_public_path__ + "static/media/jumbo_banner_3.04adbf52.jpg";